/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {BonusBunniesServerDataParser} from "../BonusBunniesServerDataParser";
import {IBonusBunniesGameData} from "./IBonusBunniesGameData";
import {IBonusSymbolQueue} from "./IBonusSymbolQueue";
import {SpinParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinParsedServerData";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";

export class BonusBunniesParsedGameData extends SpinParsedGameData {

    private readonly _winMultiplier:number;
    private readonly _randomFeatureName:string;
    private readonly _overlaySymbol:string;
    private readonly _randomFeatureTriggered:boolean;
    private readonly _overlayPositions:boolean[][];
    private readonly _overlayWildExpansions:boolean[][];
    private readonly _overlayStickyRespin:string[][];
    private readonly _overlayStickyRespinBefore:string[][];

    private readonly _bonusNewPositions:boolean[][];
    private readonly _bonusPositionsBeforeSpin:boolean[][];
    private readonly _bonusPositionsAfterSpin:boolean[][];
    private readonly _bonusSpinsRemaining:number;
    private readonly _bonusSymbolTriggered:boolean;
    private readonly _bonusSymbolCollectedBefore:number;
    private readonly _bonusSymbolCollectedAfter:number;
    private readonly _bonusValuesBeforeSpin:number[][];
    private readonly _bonusValuesAfterSpin:number[][];
    private readonly _bonusValuesLanding:number[][];
    private readonly _bottomRowActivated:boolean;
    private readonly _lastReelActivated:boolean;
    private readonly _totalBonusWinMultiplierBefore:number;
    private readonly _totalBonusWinMultiplierAfter:number;
    private readonly _bonusSymbolQueue:IBonusSymbolQueue[];
    private readonly _bonusSpinsPlayed:number;
    private readonly _reelsEnteringBonus:string[][];
    private readonly _lastBonusSymbolPositionExcitement:number[];
    private readonly _orginalReels:string[][];
    private readonly _allWinPositions:boolean[][];
    private readonly _endBonusMultiplier:number;
    private readonly _fastNearWinReels:boolean[];
    private readonly _betLineWins: IBetLineWinData[]

    private readonly _accumulatedRoundWin:string;
    public get accumulatedRoundWin():string {
        return this._accumulatedRoundWin;
    }

    constructor(rawData:IBonusBunniesGameData, dataParser:BonusBunniesServerDataParser) {
        const orginalReels:string[][] = dataParser.parseOriginalReelData(rawData);
        rawData.reels = dataParser.parseB4ReelData(rawData);
        rawData.reels = dataParser.parseReelData(rawData);
        rawData.nearWinReels = dataParser.parseNearWinData(rawData);
        rawData.freespinsLeft = rawData.bonusSpinsRemaining;
        super(rawData, dataParser);
        this._fastNearWinReels = dataParser.parseFastNearWinData(rawData);
        this._orginalReels = orginalReels;
        this._endBonusMultiplier = rawData.endBonusMultiplier;
        this._overlayWildExpansions = rawData.overlayWildExpansions;
        this._bonusNewPositions = rawData.bonusNewPositions;
        this._bonusPositionsBeforeSpin = rawData.bonusPositionsBeforeSpin;
        this._bonusPositionsAfterSpin = rawData.bonusPositionsAfterSpin;
        this._bonusSpinsRemaining = rawData.bonusSpinsRemaining;
        this._bonusSymbolTriggered = rawData.bonusSymbolTriggered;
        this._bonusSymbolCollectedBefore = rawData.bonusSymbolCollectedBefore;
        this._bonusSymbolCollectedAfter = rawData.bonusSymbolCollectedAfter;
        this._bonusValuesBeforeSpin = rawData.bonusValuesBeforeSpin;
        this._bonusValuesAfterSpin = rawData.bonusValuesAfterSpin;
        this._bonusValuesLanding = rawData.bonusValuesLanding;
        this._bottomRowActivated = rawData.bottomRowActivated;
        this._lastReelActivated = rawData.lastReelActivated;
        this._totalBonusWinMultiplierBefore = rawData.totalBonusWinMultiplierBefore;
        this._totalBonusWinMultiplierAfter = rawData.totalBonusWinMultiplierAfter;
        this._bonusSymbolQueue = dataParser.parseBonusSymbolQueueData(rawData);
        this._bonusSpinsPlayed = rawData.bonusSpinsPlayed;
        this._reelsEnteringBonus = rawData.reelsEnteringBonus;
        this._lastBonusSymbolPositionExcitement = rawData.lastBonusSymbolPositionExcitement;
        this._allWinPositions = rawData.allWinPositions;

        this._accumulatedRoundWin = rawData.accumulatedRoundWin;
        this._betLineWins = rawData.betLineWins;
    }

    get fastNearWinReels():boolean[] {
        return this._fastNearWinReels;
    }

    get winMultiplier():number {
        return this._winMultiplier;
    }

    get randomFeatureName():string {
        return this._randomFeatureName;
    }

    get overlaySymbol():string {
        return this._overlaySymbol;
    }

    get randomFeatureTriggered():boolean {
        return this._randomFeatureTriggered;
    }

    get overlayPositions():boolean[][] {
        return this._overlayPositions;
    }

    get overlayWildExpansions():boolean[][] {
        return this._overlayWildExpansions;
    }

    get overlayStickyRespin():string[][] {
        return this._overlayStickyRespin;
    }

    get overlayStickyRespinBefore():string[][] {
        return this._overlayStickyRespinBefore;
    }

    get bonusNewPositions():boolean[][] {
        return this._bonusNewPositions;
    }

    get bonusPositionsBeforeSpin():boolean[][] {
        return this._bonusPositionsBeforeSpin;
    }

    get bonusPositionsAfterSpin():boolean[][] {
        return this._bonusPositionsAfterSpin;
    }

    get bonusSpinsRemaining():number {
        return this._bonusSpinsRemaining;
    }

    get bonusSymbolTriggered():boolean {
        return this._bonusSymbolTriggered;
    }

    get bonusSymbolCollectedBefore():number {
        return this._bonusSymbolCollectedBefore;
    }

    get bonusSymbolCollectedAfter():number {
        return this._bonusSymbolCollectedAfter;
    }

    get bonusValuesBeforeSpin():number[][] {
        return this._bonusValuesBeforeSpin;
    }

    get bonusValuesAfterSpin():number[][] {
        return this._bonusValuesAfterSpin;
    }

    get bottomRowActivated():boolean {
        return this._bottomRowActivated;
    }

    get lastReelActivated():boolean {
        return this._lastReelActivated;
    }

    get totalBonusWinMultiplierBefore():number {
        return this._totalBonusWinMultiplierBefore;
    }

    get totalBonusWinMultiplierAfter():number {
        return this._totalBonusWinMultiplierAfter;
    }

    get bonusSymbolQueue():IBonusSymbolQueue[] {
        return this._bonusSymbolQueue;
    }

    get bonusSpinsPlayed():number {
        return this._bonusSpinsPlayed;
    }

    get reelsEnteringBonus():string[][] {
        return this._reelsEnteringBonus;
    }

    get lastBonusSymbolPositionExcitement():number[] {
        return this._lastBonusSymbolPositionExcitement;
    }

    get orginalReels():string[][] {
        return this._orginalReels;
    }

    get allWinPositions():boolean[][] {
        return this._allWinPositions;
    }

    get bonusValuesLanding():number[][] {
        return this._bonusValuesLanding;
    }

    get endBonusMultiplier():number {
        return this._endBonusMultiplier;
    }

    get betLineWins(): IBetLineWinData[] {
        return this._betLineWins;
    }
}